import { h } from 'preact';

import fallback from '../assets/icons/apple-touch-icon.png';

import { useState, useCallback } from 'preact/hooks';

import styles from './global.css';

export default function ResponsiveImage(props) {
  const { src, alt } = props;
  const [error, setError] = useState(null);

  const onError = useCallback(function onError() {
    setError(true);
  }, []);

  const imageSrc = error || !src ? fallback : src;

  return (
    <img
      onError={onError}
      class={styles.responsiveImage}
      src={imageSrc}
      loading="lazy"
      alt={alt}
    />
  );
}
